import React, { useState } from 'react';
const faqs = [{
  q: 'Is this suitable for beginner coaches?',
  a: 'Absolutely. Basketball Ready 360 was designed for coaches at every level — from first-year PE teachers to experienced club coaches. Everything is explained step by step with diagrams so you can use it from day one.'
}, {
  q: 'What age groups does this cover?',
  a: 'The program covers all youth age groups from U10 to U19 across three dedicated volumes, plus physical conditioning and shooting content that applies to all ages.'
}, {
  q: 'Is this a physical or digital product?',
  a: 'This is a 100% digital product. After your purchase you will receive instant access to download all PDFs directly to your device.'
}, {
  q: 'How do I receive my purchase?',
  a: 'Immediately after payment you will receive an email with your download link. You can access your files within minutes from anywhere in the world.'
}, {
  q: "What if I'm not satisfied?",
  a: "We offer a full 7-day money back guarantee. If you're not completely satisfied for any reason, contact us and we'll refund your purchase in full."
}, {
  q: 'Can I use this for school PE classes?',
  a: 'Yes. The content is perfectly structured for school PE environments. The sessions work with large groups, require minimal equipment and follow standard curriculum progressions.'
}, {
  q: 'How is this different from free resources I can find online?',
  a: 'Free resources give you individual drills or isolated sessions. Basketball Ready 360 gives you a complete system — 200+ sessions organized by age group, a full year planning calendar, tactical playbook, evaluation tools and 5 bonuses. Everything connected, structured and ready to use in under 5 minutes.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white py-16 px-4" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] text-center mb-10 tracking-tight" data-id="element-49">
          Frequently Asked <span className="text-[#FF6B00]" data-id="element-50">Questions</span>
        </h2>

        <div className="bg-white border border-[#E5E5EA] rounded-2xl divide-y divide-[#E5E5EA] overflow-hidden shadow-sm" data-id="element-51">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-[#FAFAFA] hover:bg-white transition-colors" data-id="element-52">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-53">
                  <span className="text-[#0A0A0A] font-black text-base" data-id="element-54">
                    {faq.q}
                  </span>
                  <span className={`text-[#FF6B00] text-xl font-black flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-55">
                    +
                  </span>
                </button>
                {isOpen && <div className="px-6 pb-5 -mt-2" data-id="element-56">
                    <p className="text-[#5A5A66] text-sm sm:text-base font-medium leading-relaxed" data-id="element-57">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}